import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import userManager from '../lib/userManager'
import Loading from '../components/Loading'

export default function SSOCallback() {
    const navigate = useNavigate()

    useEffect(() => {
        async function go() {
            const user = await userManager.getUser()
            if (!user) {
                userManager
                    .signinRedirectCallback()
                    .then(() => navigate('/'))
                    .catch(err => console.error(err))
            } else {
                navigate('/')
            }
        }
        go()
    }, [])

    return <Loading title="Success!" message="Redirecting you to Tada! Admin Portal." />
}
